import styled from 'styled-components';

import { breakpoints, colors } from '../../constants';

interface IProps {
    active: boolean;
    isDisabled: boolean;
    activeTextColor: string;
}

export const ListItem = styled.h3<IProps>`
    border-bottom: ${({ active, activeTextColor }) =>
        active && `4px solid ${activeTextColor}`};
    font-weight: ${({ active }) => (active ? 700 : 400)};
    user-select: none;
    cursor: pointer;
    font-size: 1.6rem;
    padding-bottom: 15px;
    color: ${({ isDisabled, active, activeTextColor }) =>
        isDisabled
            ? colors.transparentBlack
            : active
            ? activeTextColor
            : colors.black};

    @media (${breakpoints.mediumMin}) {
        font-size: 1.8rem;
    }
`;
